const routes = [
  {
    path: "/auth",
    component: ()=> import(/* webpackChunkName: "AuthIndex" */ "./views/AuthIndex"),
    children: [
      {
        path: "logincode:lang",
        name: "logincode",
        component: () => import(/* webpackChunkName: "LoginWithCode" */ "./views/ExternalLoginWithCode"),
        meta: {
          skipBusinessLoaded: true
        }
      },
      {
        path: "resetpassword",
        name: "resetpassword",
        component: () => import(/* webpackChunkName: "AuthRoutes" */ "./views/resetPasswords/ResetPasswordFromEmail"),
        props: route => ({
          resetPasswordToken: route.query.token
        }),
        meta: {
          skipBusinessLoaded: true
        }
      },
      {
        path: "forgotpassword",
        name: "forgotpassword",
        component: () => import(/* webpackChunkName: "AuthRoutes" */ "./views/ForgotPassword"),
        props: route => ({
            shouldDisplayLinkInvalidMessage: route.params.shouldDisplayLinkInvalidMessage,
            email: route.query.email
        }),
        meta: {
          skipBusinessLoaded: true
        }
      },
      {
        path: "setstaffpassword",
        name: "setstaffpassword",
        component: () => import(/* webpackChunkName: "AuthRoutes" */ "./views/resetPasswords/SetStaffPassword"),
        props: route => ({
          authToken: route.query.auth_token
        }),
        meta: {
          skipBusinessLoaded: true
        }
      },
      {
        path: "/login",
        name: "login",
        component: () => import(/* webpackChunkName: "AuthRoutes" */ "./views/Login"),
        meta: {
          skipBusinessLoaded: true
        }
      },
      {
        path: "*",
        redirect: { name: "login" }
      }
    ]
  }
];
export default routes;
